import { useState } from "react"

import type {
  AttributesDismiss,
  UseDismissModalProps
} from "./useDismissModal.types"

export type * from "./useDismissModal.types"

export const useDismissModal = (props: UseDismissModalProps) => {
  const getInitialState = () => ({ open: false, loading: false })
  const [state, setState] = useState(getInitialState())
  const resetToInitialState = () => setState(getInitialState())

  const onOk = (attr: AttributesDismiss) => {
    props.onOk(attr)
    resetToInitialState()
  }

  const asyncOk = async (attr: AttributesDismiss) => {
    try {
      setState({ open: true, loading: true })

      await props.onOk(attr)
    } finally {
      resetToInitialState()
    }
  }

  const openModal = () => {
    setState({ open: true, loading: false })
  }
  const onCancel = () => resetToInitialState()

  return { openModal, onOk, asyncOk, onCancel, ...state } as const
}
